import { useState } from "react";
import React from "react";
import { autoUpdate, FloatingPortal, useFloating } from "@floating-ui/react";
import Icon from "../Icon/Icon";
import NumPad from "../PosCart/NumPad";
import Textfield, { TextFieldProps } from "./Textfield";
import usePortalRoot from "@/shared/hooks/usePortalRoot";

interface TextfieldWithNumPadProps extends TextFieldProps {
  value?: string | number;
  setValue: (value: string) => void;
  align?: "left" | "right";
  defaultValue?: string | number;
  showNumPad?: boolean;
}

const TextfieldWithNumPad = React.forwardRef<
  HTMLInputElement,
  TextfieldWithNumPadProps
>(
  (
    {
      value,
      setValue,
      align = "right",
      defaultValue,
      showNumPad: showNumPadProp = false,
      ...props
    },
    ref
  ) => {
    const [showNumPad, setShowNumPad] = useState(showNumPadProp);
    const portalRoot = usePortalRoot();

    const { refs, floatingStyles } = useFloating({
      open: showNumPad,
      placement: align === "left" ? "bottom-start" : "bottom-end",
      whileElementsMounted: autoUpdate,
    });

    return (
      <div ref={refs.setReference} className="flex items-end gap-2">
        <Textfield
          type="number"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          ref={ref}
          defaultValue={defaultValue}
          {...props}
          isRightAddonClickable
          onClickRightAddon={() => setShowNumPad(true)}
          rightAddonPadding="0.25rem 1rem"
          inputRightAddon={
            <Icon className="size-12 fill-dark" variants="keyboard" />
          }
        />
        {showNumPad && (
          <FloatingPortal root={portalRoot}>
            <div
              ref={refs.setFloating}
              style={floatingStyles}
              className="z-999999"
              data-ignore-click-outside
            >
              <NumPad
                show={showNumPad}
                onExit={(money) => {
                  setShowNumPad(false);
                  money && setValue(money);
                }}
              />
            </div>
          </FloatingPortal>
        )}
      </div>
    );
  }
);

export default TextfieldWithNumPad;
